export const resetPasswordSuccessMessage = $ => $.resetPasswordSuccessMessage;

export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/getters/log-in.js